import { Map, AdvancedMarker, useMap, useAdvancedMarkerRef } from "@vis.gl/react-google-maps"
import { FC, useEffect } from "react";

type Props = {
  selectedPlace: any
}

export const GoogleMap: FC<Props> = ({selectedPlace}) => {
  const [markerRef, marker] = useAdvancedMarkerRef();

  if(!selectedPlace)
    return <></>;

  return (
    <div className="map my-3">
      <Map
        style={{height: '160px'}}
        mapId={'bf51a910020fa25a'}
        defaultZoom={3}
        defaultCenter={{ lat: 22.54992, lng: 0 }}
        gestureHandling={'greedy'}
        disableDefaultUI={true}
      >
        <AdvancedMarker ref={markerRef} position={null} />
      </Map>
      <MapHandler place={selectedPlace} marker={marker} />
    </div>
  )
}

interface MapHandlerProps {
  place: google.maps.places.PlaceResult | null;
  marker: google.maps.marker.AdvancedMarkerElement | null;
}

const MapHandler = ({ place, marker }: MapHandlerProps) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !place || !marker) return;

    if (place.geometry?.viewport) {
      map.fitBounds(place.geometry?.viewport);
    }
    marker.position = place.geometry?.location;
  }, [map, place, marker]);

  return null;
};